<template>
  <div>
    <el-upload
      class="avatar-uploader"
      :action="'/wechat/api/card_product/upload?token=' + this.token()"
      :show-file-list="false"
      :on-success="handleImageSuccess"
      :before-upload="beforeImgUpload">
      <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<script>
import {getToken} from '@/utils/auth'

export default {
  props: ['value'],
  data () {
    return {
      imageUrl: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.imageUrl = val
      }
    }
  },
  methods: {
    token () {
      return getToken()
    },
    handleImageSuccess (res, file) {
      this.imageUrl = res.data.path
      this.$emit('input', res.data.path)
    },
    beforeImgUpload (file) {
      const isImage = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isImage && isLt2M
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/WechatCardProductImg.vue